class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* OUTFAIR (growth batch 2026-10-30): Complete the look in the cart drawer.
   Fetches Shopify recommendations (intent=related) for the first cart item,
   renders up to 3 products not already in the cart, and adds via
   /cart/add.js, then re-renders the drawer sections like the theme does. */
(function () {
  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function refreshDrawer() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        if (sections['cart-drawer']) {
          var fresh = new DOMParser()
            .parseFromString(sections['cart-drawer'], 'text/html')
            .querySelector('#CartDrawer');
          var current = document.getElementById('CartDrawer');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        }
        if (sections['cart-icon-bubble']) {
          var freshBubble = new DOMParser()
            .parseFromString(sections['cart-icon-bubble'], 'text/html')
            .querySelector('.shopify-section');
          var bubble = document.getElementById('cart-icon-bubble');
          if (freshBubble && bubble) bubble.innerHTML = freshBubble.innerHTML;
        }
      })
      .catch(function () {});
  }

  function addToCart(button, variantId) {
    button.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        return refreshDrawer();
      })
      .catch(function () {
        button.disabled = false;
      });
  }

  function initCtl(container) {
    if (!container || container.dataset.ctlReady) return;
    container.dataset.ctlReady = 'true';
    var productId = container.getAttribute('data-product-id');
    if (!productId) return;
    var inCart = (container.getAttribute('data-in-cart') || '').split(',');
    var url =
      '/recommendations/products.json?product_id=' +
      encodeURIComponent(productId) +
      '&intent=related&limit=6';
    fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var list = container.querySelector('[data-ctl-list]');
        if (!list) return;
        var shown = 0;
        ((data && data.products) || []).forEach(function (p) {
          if (shown >= 3) return;
          if (inCart.indexOf(String(p.id)) !== -1) return;
          var variant = (p.variants || []).filter(function (v) {
            return v.available;
          })[0];
          if (!variant) return;
          shown++;
          var item = document.createElement('div');
          item.className = 'cart-drawer__ctl-item';
          item.innerHTML =
            '<a class="cart-drawer__ctl-link" href="/products/' +
            p.handle +
            '">' +
            (p.images && p.images[0]
              ? '<img class="cart-drawer__ctl-img" src="' + p.images[0] + '" alt="" loading="lazy" width="150" height="150">'
              : '') +
            '<span class="cart-drawer__ctl-title"></span>' +
            '<span class="cart-drawer__ctl-price">' +
            formatMoney(p.price) +
            '</span></a>' +
            '<button type="button" class="button button--secondary cart-drawer__ctl-add">Add</button>';
          item.querySelector('.cart-drawer__ctl-title').textContent = p.title;
          var button = item.querySelector('.cart-drawer__ctl-add');
          button.addEventListener('click', function () {
            addToCart(button, variant.id);
          });
          list.appendChild(item);
        });
        if (shown > 0) container.hidden = false;
      })
      .catch(function () {});
  }

  function scan() {
    document.querySelectorAll('[data-ctl]').forEach(initCtl);
  }

  function boot() {
    scan();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(scan).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
